import { CustomFields } from '../../../cimsPage/instances/admin'
import { CreateViewEditSoftRemoveRestore } from '../../common'

const customFields = CreateViewEditSoftRemoveRestore({
  page: CustomFields,
  object: 'Custom Field',
  view: '88e90070-a463-4b9b-af35-33307a436d37',
  create: 'b8640a0f-80c9-4825-9bd2-5a31c04e7446',
  edit: 'e3e9d221-bd6e-4dca-ac90-6117d986eb46',
  removeRestore: 'eb23cfae-4034-440c-8d48-8687b1dd03d2',
})

export const ViewCustomField = customFields.View
export const CreateCustomField = customFields.Create
export const EditCustomField = customFields.Edit
export const RemoveRestoreCustomField = customFields.RemoveRestore

export type CustomFieldPermission =
  | typeof ViewCustomField
  | typeof CreateCustomField
  | typeof EditCustomField
  | typeof RemoveRestoreCustomField
